import React from 'react';
import { useNavigate } from 'react-router-dom';

const GlobalFooter = () => {
  const navigate = useNavigate();

  const navigationLinks = [
    { name: 'Home', path: '/' },
    { name: 'How it Works', path: '/how-it-works' },
    { name: 'About Us', path: '/about' },
    { name: 'Partner Restaurants', path: '/partner-restaurants' },
    { name: 'Partner NGOs', path: '/partner-ngos' },
    { name: 'Volunteer Network', path: '/volunteer-network' },
    { name: 'Terms & Conditions', path: '/terms-and-conditions' },
    { name: 'Privacy Policy', path: '/privacy-policy' }
  ];

  // Split navigation links into two columns
  const midPoint = Math.ceil(navigationLinks.length / 2);
  const column2Links = navigationLinks.slice(0, midPoint);
  const column3Links = navigationLinks.slice(midPoint);

  return (
    <footer className="bg-gray-900 text-white">
      {/* Main Footer - 4 Column Structure */}
      <div className="border-b border-gray-800">
        <div className="container mx-auto px-4 py-12">
          <div className="max-w-5xl mx-auto">
            <div className="grid grid-cols-1 md:grid-cols-4 gap-6 items-center">
              {/* Column 1 - Logo Only (Prominent) */}
              <div className="flex flex-col items-center justify-center">
                <img 
                  src="/logo.png" 
                  alt="Food Connect Logo" 
                  className="h-24 w-auto"
                />
              </div>

              {/* Column 2 - Tagline */}
              <div className="flex flex-col justify-center items-center">
                <div className="text-center">
                  <div className="text-2xl font-bold mb-2">Food Connect</div>
                  <div className="text-gray-300 text-base leading-relaxed">
                    Connecting Surplus to Smiles
                  </div>
                </div>
              </div>

              {/* Column 3 - First Half of Navigation Links */}
              <div className="flex flex-col space-y-3 items-center">
                {column2Links.map((link) => (
                  <button
                    key={link.path}
                    onClick={() => navigate(link.path)}
                    className="text-gray-300 hover:text-white transition-colors text-sm font-medium text-center"
                  >
                    {link.name}
                  </button>
                ))}
              </div>

              {/* Column 4 - Second Half of Navigation Links */}
              <div className="flex flex-col space-y-3 items-center">
                {column3Links.map((link) => (
                  <button
                    key={link.path}
                    onClick={() => navigate(link.path)}
                    className="text-gray-300 hover:text-white transition-colors text-sm font-medium text-center"
                  >
                    {link.name}
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Row - Copyright Bar */}
      <div className="bg-gray-950">
        <div className="container mx-auto px-4 py-4">
          <div className="text-center text-gray-400 text-sm">
            © 2025 Food Connect. All rights reserved. Founded by{' '}
            <a href="https://www.riyakamat.com/ventures" target="_blank" rel="noopener noreferrer" className="text-green-400 hover:text-green-300 transition-colors">Riya Kamat</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default GlobalFooter;